import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { metaReducers } from './+state/storage.metareducer';
import { WebsocketEffects } from './+state/websocket.effects';

import * as fromWebsocket from './+state/websocket.reducer';

const SERVICES = [
];

const MODULES = [
  CommonModule,
];

const STATE_MODULES = [
  StoreModule.forFeature(fromWebsocket.websocketFeatureKey, fromWebsocket.reducer, { metaReducers }),
  EffectsModule.forFeature([WebsocketEffects]),
];

@NgModule({
  imports: [
    MODULES,
    STATE_MODULES,
  ],
  providers: [SERVICES]
})
export class StateWebsocketModule { }
